/* eslint-disable max-len */

import React from 'react';
import ReactGA from 'react-ga';
import Badge from '@material-ui/core/Badge';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import TextField from '@material-ui/core/TextField';
import {I18n} from 'react-redux-i18n';
import {filter, size} from 'lodash';
import {connect} from 'react-redux';
import AbstractLibraryFilters from './AbstractLibraryFilters';
import ChipsFilter from './ChipsFilter';
import Contrained from './ConstrainedFilters';
import {viewMode} from '../../Library/constants';
import {changeViewMode} from '../../Library/LibraryActions';
import MultipleSelectFilter from './MultipleSelectFilter';
import {filterHiddensOERs} from '../../app/configuration/util';

class DesktopFilters extends AbstractLibraryFilters {
  state = {
    open: false,
    oerTypeFilter: [],
    groupsFilter: [],
    terminalsFilter: [],
    constrainedFilters: {},
    mediaId: ''
  }

  updateFromProps(props) {
    const {
      oerTypes,
      groupsFilter,
      terminalsFilter,
      oerTypeFilter,
      startTime,
      endTime,
      constrainedFilters,
      filters,
      mediaId
    } = props || this.props;

    const {sortBy} = filters;
    
    this.setState({
      groupsFilter,
      terminalsFilter,
      oerTypeFilter,
      startTime,
      endTime,
      sortBy,
      constrainedFilters,
      oerTypes,
      mediaId
    });
  }

  componentWillReceiveProps(props) {
    this.updateFromProps(props);
  }

  handleMediaId = ({target}) => {
    this.setState({mediaId: target.value});
  }

  componentWillMount() {
    this.props.loadGroups();
    this.props.loadOerTypes();
    this.props.loadTerminals();
  }

  updateChipFilter = chips => {
    this.props.updateChipFilter(chips);
    // TODO: add other filters
    this.applyFilter({chipsFilter: chips});
  }

  applyDateFilter = filters => {
    this.applyFilter(filters);
  }

  applyFilter = filters => {
    const {
      groupsFilter,
      terminalsFilter,
      oerTypeFilter,
      constrainedFilters,
      mediaId,
      startTime,
      endTime,
      sortBy
    } = this.state;

    const {chipsFilter} = this.props;

    this.props.applyFilter({
      groupsFilter, constrainedFilters, terminalsFilter, oerTypeFilter, chipsFilter, mediaId, startTime, endTime, sortBy, ...filters
    });
    this.props.updateConstrainedFilters(constrainedFilters);
  }

  filterCount() {
    const {
      groupsFilter,
      constrainedFilters,
      terminalsFilter,
      oerTypeFilter,
      mediaId
    } = this.props;

    const count = size(groupsFilter) +
      size(terminalsFilter) +
      size(oerTypeFilter) +
      size(filter(constrainedFilters, i => i === true)) +
      (mediaId ? 1 : 0);

    return count;
  }

  handleGroupSelection = value => {
    this.setState({groupsFilter: value});

    ReactGA.event({
      category: 'Library Filter',
      action: 'Groups',
      label: 'Multiple Select'
    });
  }

  handleTerminalsSelection = value => {
    this.setState({terminalsFilter: value});

    ReactGA.event({
      category: 'Library Filter',
      action: 'Terminals',
      label: 'Multiple Select'
    });
  }

  handleOerSelection = value => {
    this.setState({oerTypeFilter: value});

    ReactGA.event({
      category: 'Library Filter',
      action: 'OER Type',
      label: 'Multiple Select'
    });
  }

  handleOnClear = () => {
    this.setState({
      open: false,
      groupsFilter: [],
      terminalsFilter: [],
      oerTypeFilter: [],
      constrainedFilters: {},
      mediaId: ''
    }, this.applyFilter);
  }
  handleOnApply = () => {
    this.setState({open: false});
    this.applyFilter({});
  }
  handleOpen = () => this.setState({open: true});
  handleRequestClose = () => {
    this.setState({open: false});
    this.updateFromProps();
  }

  handleChangeViewMode = () => {
    this.props.changeViewMode(this.props.viewMode === viewMode.CARD ? viewMode.LIST : viewMode.CARD);
  }

  updateConstrainedFilters = filters => {
    this.setState({constrainedFilters: filters});
  }


  render() {
    const {sortBy} = this.props.filters;
    return (
      <div className="desktopfilters">
        <ChipsFilter
          startTime={this.props.startTime}
          endTime={this.props.endTime}
          sortBy={sortBy}
          searchDriverVehicle={this.props.searchDriverVehicle}
          updateChipFilter={this.updateChipFilter}
          driversVehiclesList={this.props.driversVehiclesList}
          chipsFilter={this.props.chipsFilter}
          handleOnDateApply={this.applyDateFilter}
          isLoading={this.props.isLoading}
          isMobile={false}
        />
        <IconButton onClick={this.handleOpen} className="desktopfilters__filtericon" id="filterIcon">
          <Badge showZero badgeContent={this.filterCount()} className="viappbar__badge-yellow">
            <Icon color="inherit" className="desktopfilters__ddicon">filter_list</Icon>
          </Badge>
        </IconButton>
        <IconButton onClick={this.handleChangeViewMode} className="desktopfilters__filtericon" id="viewModeIcon">
          <Icon color="inherit" className="desktopfilters__ddicon">{this.props.viewMode === viewMode.CARD ? 'format_list_bulleted' : 'view_module'}</Icon>
        </IconButton>
        <Dialog
          open={this.state.open}
          onClose={this.handleRequestClose}
          BackdropProps={{
            invisible: true
          }}
          classes={{
            root: 'libraryfilter',
            paper: 'libraryfilter__paper'
          }}
        >
          <List className="librarylist desktopfilters__list">
            <ListItem id="filterTerminal">
              <MultipleSelectFilter
                options={this.props.terminals}
                label={I18n.t('filter.terminal.label')}
                value={this.state.terminalsFilter}
                onChange={this.handleTerminalsSelection}
                isMobile={false}
              />
            </ListItem>
            <ListItem id="filterGroup">
              <MultipleSelectFilter
                options={this.props.groups}
                label={I18n.t('filter.group.label')}
                value={this.state.groupsFilter}
                onChange={this.handleGroupSelection}
                isMobile={false}
              />
            </ListItem>
            <ListItem id="filterOer">
              <MultipleSelectFilter
                options={this.state.oerTypes}
                label={I18n.t('filter.oer.label')}
                value={this.state.oerTypeFilter}
                onChange={this.handleOerSelection}
                isMobile={false}
              />
            </ListItem>
            <ListItem>
              <TextField
                placeholder={I18n.t('filter.mediaId.label')}
                onChange={this.handleMediaId}
                value={this.state.mediaId}
                fullWidth
                id="filterMediaId"
              />
            </ListItem>
            <Contrained updateFilters={this.updateConstrainedFilters} {...this.state.constrainedFilters} />
            <ListItem className="desktopfilters__actions">
              <Button variant="contained" onClick={this.handleOnClear} id="filterClear" className="btn btn-secondary">{I18n.t('action.clear')}</Button>
              <Button variant="contained" onClick={this.handleOnApply} color="primary" className="btn btn-primary" id="filterApply">
                {I18n.t('action.apply')}
              </Button>
            </ListItem>
          </List>
        </Dialog>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {library} = state;
  return {
    locale: state.i18n.locale,
    viewMode: library.viewMode,
    oerTypes: filterHiddensOERs(state)
  };
}

export default connect(mapStateToProps, {changeViewMode})(DesktopFilters);
